export default __webpack_public_path__ + "87ffac5a080228abd8189830509f993d.webp";